import { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAgencyManagerUsers } from 'redux/selectors';
import * as Comp from 'components';
import { MenuItem } from '@mui/material';
import * as services from 'services';
import * as helper from 'helpers';
import { getAgencyUser } from 'redux/selectors';
import InviteAssignment from '../SendInvites/components/InviteAssignment';
import BasicInfo from './BasicInfo';
import styles from './form.module.css';
import { setUpdateRole } from 'redux/reducers/userReducer';

const ChangeRole = (props) => {
	const dispatch = useDispatch();
	const user = useSelector(getAgencyUser(props.id));
	const managerList = useSelector(getAgencyManagerUsers);

	const [role, setRole] = useState('social-worker');
	const [manager, setManager] = useState('');
	const [branch, setBranch] = useState('');
	const [branchList, setBranchList] = useState([]);

	useEffect(() => {
		if (role === 'manager') {
			getList();
		}
	}, [role]);

	useEffect(() => {
		dispatch(setUpdateRole({}));
		setRole(user.role);
	}, [user]);

	const getList = useCallback(async () => {
		services.getBranchList().then((result) => {
			setBranchList(helper.listSortOrganizationByName(result.data || []));
		});
	}, []);

	const selectManager = (e) => {
		setManager(e.target.value);
		dispatch(
			setUpdateRole({
				role: 'social-worker',
				managerAgencyUserId: e.target.value,
			})
		);
	};

	const selectBranch = (e) => {
		setBranch(e.target.value);
		dispatch(setUpdateRole({ role: 'manager', branchId: e.target.value }));
	};

	const onChange = (e) => {
		setRole(e);
		setBranch('');
		setManager('');
		dispatch(setUpdateRole({ role: e, branchId: '', managerAgencyUserId: '' }));
	};

	const managerMap =
		managerList &&
		Boolean(managerList.length) &&
		managerList.map((val) => {
			return (
				<MenuItem key={val.id} value={val.id}>
					{val.firstname ? `${val.firstname} ${val.lastname}` : val.email}
				</MenuItem>
			);
		});

	const branchMap =
		branchList &&
		Boolean(branchList.length) &&
		branchList.map((val) => {
			return (
				<MenuItem key={val.id} value={val.id}>
					{val.name}
				</MenuItem>
			);
		});

	const originalRole = user.role;

	const textInfo = () => {
		if (originalRole === 'social-worker' && role === 'manager') {
			return (
				<div className={styles.changeRoleText}>
					Changing This Role Will: <br />
					* Remove association with manager <br />* Remove direct association to
					child <br /> * Clear out extended permissions
				</div>
			);
		}
		if (originalRole === 'social-worker' && role === 'admin') {
			return (
				<div className={styles.changeRoleText}>
					Changing This Role Will: <br />
					* Remove association with manager <br />* Remove direct association to
					child
				</div>
			);
		}
		if (originalRole === 'manager') {
			return (
				<div className={styles.changeRoleText}>
					Changing This Role Will: <br />
					* Remove branch
					<br />* Social Workers will be unassigned
				</div>
			);
		}
	};

	return (
		<div className={styles.agencyInviteContent}>
			<BasicInfo />
			<Comp.RoleSelector
				role={role}
				onChange={onChange}
				disableAdmin={false}
				originalRole={originalRole}
			/>
			{originalRole !== 'manager' && role === 'manager' && (
				<InviteAssignment
					label='Branch'
					required={true}
					value={branch}
					onSelect={selectBranch}
					listMap={branchMap}
				/>
			)}
			{originalRole !== 'social-worker' && role === 'social-worker' && (
				<InviteAssignment
					label='Manager'
					required={false}
					value={manager}
					onSelect={selectManager}
					listMap={managerMap}
				/>
			)}
			{textInfo()}
		</div>
	);
};

export default ChangeRole;
